import React, { Component } from 'react'
import moment from 'moment'
import { Button } from '@material-ui/core';
import { CustomerEditDetails } from './customer-edit-details'
import { EditAccountType } from './account-edit-account-type'

export default class CustomerDetails extends Component {
    state = {
        newAccountName: this.props.account.name,
        newAccountType: this.props.account.type,
        isShowingEditModal: false,
        isShowingAccountTypeEditModal: false
    }

    openEditModal = () => {
        this.setState({ isShowingEditModal: true })
    }

    closeEditModal = () => {
        this.setState({ isShowingEditModal: false })
    }

    openAccountTypeEditModal = () => {
        this.setState({ isShowingAccountTypeEditModal: true })
    }

    closeAccountTypeEditModal = () => {
        this.setState({ isShowingAccountTypeEditModal: false })
    }

    render() {
        let registrationDate = '';
        if (this.props.account && this.props.account.creationTime) {
            let dateObj = new Date(this.props.account.creationTime);
            registrationDate = moment(dateObj).format('MMM D - YYYY')
        }

        return (
            <div>
                <div className="each-customer-info">
                    <div className="col-lg-10 col-sm-12 personal-info">
                        <div className="col-lg-3 col-md-4 col-xs-6 row">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label htmlFor="accountName">Customer</label>
                                <Button onClick={this.openEditModal} color="primary">EDIT</Button>
                            </div>
                            <p id="accountName">{this.props.account.name}</p>
                        </div>
                        <div className="col-lg-3 col-md-4 col-xs-6 row">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label htmlFor="accountType">Type</label>
                                <Button onClick={this.openAccountTypeEditModal} color="primary">EDIT</Button>
                            </div>
                            <p id="accountType">{this.props.account.type}</p>
                        </div>
                        <div className="col-lg-3 col-md-4 col-xs-6 row">
                            <label htmlFor="registrationDate">Created</label>
                            <p id="registrationDate">{registrationDate}</p>
                        </div>
                       
                    </div>
                    <div className="col-md-2 col-sm-12 col-xs-12 accountActive">
                        Account Active
                        <center>
                            <div className="switch">
                                <input id="cmn-toggle-1" className="cmn-toggle cmn-toggle-round" type="checkbox" onChange={this.props.toggleAccountActive} checked={this.props.accountState == "ACTIVE"} />
                                <label htmlFor="cmn-toggle-1"></label>
                            </div>
                        </center>
                    </div>
                </div>

                <CustomerEditDetails 
                    isOpen={this.state.isShowingEditModal}
                    onClose={this.closeEditModal}
                    updateAccountName={this.props.updateAccountName}
                />
                <EditAccountType 
                    isOpen={this.state.isShowingAccountTypeEditModal}
                    onClose={this.closeAccountTypeEditModal}
                    updateAccountType={this.props.updateAccountType}
                />
            </div>
        ) // return
    } // render
}// CustomerInformation
